import { useClient } from "../context";

export function useChainId() {
  const client = useClient()
  return client.data?.chain?.id
}